import React from "react";
import img from "../../Assets/Images/top1.png";
import { Mail, PhoneCall } from "lucide-react";

const TopNavbar = () => {
  return (
    <>
      {/* Desktop Version */}
      <div className="hidden md:flex bg-[#020316] w-full py-2 px-6 justify-between items-center border-b border-gray-200">
        <a href="https://covenant-construction.vercel.app/" className="cursor-pointer">
          <img src={img} alt="logo" className="h-5 w-40" />
        </a>

        <div className="flex items-center space-x-4">
          <a
            href="mailto:covenantsdevelopers@gmail.com"
            className="flex items-center text-sm text-white space-x-1 hover:underline"
          >
            <Mail size={16} />
            <span>covenantsdevelopers@gmail.com</span>
          </a>

          <a
            href="tel:7737373307"
            className="flex items-center text-sm text-white space-x-1 hover:underline"
          >
            <PhoneCall size={16} />
            <span>7737373307</span>
          </a>

          <a
            href="tel:6372664851"
            className="flex items-center text-sm text-white space-x-1 hover:underline"
          >
            <PhoneCall size={16} />
            <span>6372664851</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default TopNavbar;